import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_b_input_group, null, {
            default: _withCtx(() => [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedMonthOption,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedMonthOption) = $event)),
                    options: _ctx.monthOptions,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select month/year",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"]),
                _createTextVNode(),
                (_ctx.isCustom)
                    ? (_openBlock(), _createBlock(_component_b_input_group_append, { key: 0 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_flat_pickr, {
                                modelValue: _ctx.customDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.customDate) = $event)),
                                config: _ctx.flatPickrConfig,
                                class: "form-control",
                                placeholder: "Select month/year"
                            }, null, 8 /* PROPS */, ["modelValue", "config"])
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
